<style src="vue-select/dist/vue-select.css"></style>
<style>
.table-hover {
    width: 100%;
    table-layout: fixed;
}

.table-sm {
    font-size: 14px;
}
</style>

<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card card-outline card-primary shadow-sm">

                        <!-- HEADER -->
                        <div class="card-header d-flex align-items-center justify-content-between flex-wrap p-3">
                            <h3 class="card-title font-weight-bold text-uppercase m-0">
                                <i class="fas fa-th text-primary mr-2"></i>
                                Matriks Tagihan Tahunan
                            </h3>
                            <div class="card-tools d-flex align-items-center mt-2 mt-sm-0">
                                <button class="btn btn-sm btn-success mr-2" @click="exportToExcel" :disabled="loading || exporting">
                                    <i class="fas" :class="exporting ? 'fa-spinner fa-spin' : 'fa-file-excel'"></i>
                                    <span class="ml-1">{{ exporting ? 'Mengekspor...' : 'Export Excel' }}</span>
                                </button>
                                <button class="btn btn-sm btn-outline-secondary" @click="fetchData" :disabled="loading" title="Refresh">
                                    <i class="fas fa-sync-alt" :class="{ 'fa-spin': loading }"></i>
                                </button>
                            </div>
                        </div>

                        <!-- BODY -->
                        <div class="card-body p-3">

                            <!-- TABS (PPPOE & CORPORATE) -->
                            <ul class="nav nav-pills custom-nav-pills mb-3" role="tablist">
                                <li class="nav-item">
                                    <a class="nav-link font-weight-bold cursor-pointer"
                                       :class="{ active: filter.tipe === 1 }"
                                       @click="changeTab(1)">
                                        <i class="fa fa-user-alt mr-2"></i>
                                        PPOE
                                    </a>
                                </li>
                                <li class="nav-item ml-2">
                                    <a class="nav-link font-weight-bold cursor-pointer"
                                       :class="{ active: filter.tipe === 2 }"
                                       @click="changeTab(2)">
                                        <i class="fa fa-building mr-2"></i>
                                        KORPORAT
                                    </a>
                                </li>
                            </ul>

                            <!-- FILTER SECTION -->
                            <div class="filter-box p-3 mb-3 bg-light rounded border">
                                <div class="row align-items-center">
                                    <!-- Filter Tahun -->
                                    <div class="col-12 col-sm-6 col-md-2 mb-2">
                                        <label class="small font-weight-bold mb-1">Tahun</label>
                                        <v-select
                                            v-model="filter.tahun"
                                            :items="yearOptions"
                                            outlined
                                            dense
                                            hide-details
                                            @change="onFilterChange"
                                            class="bg-white rounded"
                                        />
                                    </div>

                                    <!-- Filter Cabang -->
                                    <div class="col-12 col-sm-6 col-md-3 mb-2">
                                        <label class="small font-weight-bold mb-1">Cabang</label>
                                        <KantorCabang
                                            v-model="filter.kantor"
                                            label="Semua Cabang"
                                            @input="onFilterChange"
                                            class="bg-white rounded"
                                        />
                                    </div>

                                    <!-- Filter Status Pelanggan -->
                                    <div class="col-12 col-sm-6 col-md-3 mb-2">
                                        <label class="small font-weight-bold mb-1">Status Pelanggan</label>
                                        <v-select
                                            v-model="filter.status_active"
                                            :items="statusOptions"
                                            item-text="text"
                                            item-value="value"
                                            outlined
                                            dense
                                            hide-details
                                            @change="onFilterChange"
                                            class="bg-white rounded"
                                        />
                                    </div>

                                    <!-- Filter Cari -->
                                    <div class="col-12 col-sm-6 col-md-4 mb-2">
                                        <label class="small font-weight-bold mb-1">Cari ID / Nama</label>
                                        <TextSearch
                                            v-model="filter.search"
                                            label="Ketik ID atau nama..."
                                            @input="onSearchInput"
                                            class="bg-white rounded"
                                        />
                                    </div>
                                </div>

                                <!-- LEGEND & SUMMARY BAR -->
                                <div class="d-flex align-items-center justify-content-between flex-wrap pt-2 mt-2 border-top">
                                    <div class="legend-container d-flex align-items-center flex-wrap">
                                        <span class="small font-weight-bold mr-3 text-muted">Keterangan:</span>
                                        <span class="legend-item mr-3">
                                            <span class="legend-badge legend-paid">
                                                <i class="fas fa-check"></i>
                                            </span>
                                            <span class="small font-weight-bold ml-1 text-success">Lunas (PAID)</span>
                                        </span>
                                        <span class="legend-item mr-3">
                                            <span class="legend-badge legend-unpaid">
                                                <i class="fas fa-times"></i>
                                            </span>
                                            <span class="small font-weight-bold ml-1 text-danger">Belum Lunas (UNPAID)</span>
                                        </span>
                                        <span class="legend-item mr-3">
                                            <span class="legend-badge legend-empty">-</span>
                                            <span class="small ml-1 text-muted">Tidak Ada Tagihan</span>
                                        </span>
                                    </div>

                                    <div class="summary-badge mt-2 mt-md-0">
                                        <span class="badge badge-info py-2 px-3">
                                            <i class="fas fa-users mr-1"></i>
                                            Total: <strong>{{ totalItems }}</strong> Pelanggan
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- TABLE WRAPPER -->
                            <div class="table-responsive-wrapper position-relative">
                                <!-- Loading overlay -->
                                <div v-if="loading" class="loading-overlay">
                                    <div class="spinner-border text-primary" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <div class="mt-2 font-weight-bold text-primary">Memuat data rekap...</div>
                                </div>

                                <table class="table table-bordered table-hover rekap-tahunan-table mb-0">
                                    <thead>
                                        <tr class="header-row-1">
                                            <th rowspan="2" class="text-center align-middle col-no">No</th>
                                            <th rowspan="2" class="text-left align-middle col-inet">ID</th>
                                            <th rowspan="2" class="text-left align-middle col-nama">nama</th>
                                            <th colspan="12" class="text-center align-middle col-bulan-header">
                                                Bulan (Tahun {{ filter.tahun }})
                                            </th>
                                        </tr>
                                        <tr class="header-row-2">
                                            <th v-for="m in 12" :key="m" class="text-center align-middle col-month-num" :title="getMonthName(m) + ' ' + filter.tahun">
                                                {{ m }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="items.length === 0 && !loading">
                                            <td colspan="15" class="text-center py-4 text-muted">
                                                <i class="fas fa-inbox fa-3x mb-2 d-block text-secondary"></i>
                                                Tidak ada data pelanggan untuk filter yang dipilih
                                            </td>
                                        </tr>

                                        <tr v-for="(item, index) in items" :key="item.id">
                                            <!-- No -->
                                            <td class="text-center align-middle font-weight-normal text-muted">
                                                {{ (pagination.page - 1) * pagination.itemsPerPage + index + 1 }}
                                            </td>

                                            <!-- ID (rata kiri) -->
                                            <td class="text-left align-middle font-weight-bold inet-id-cell">
                                                {{ item.id }}
                                            </td>

                                            <!-- nama -->
                                            <td class="align-middle text-left nama-cell">
                                                <div class="d-flex align-items-center justify-content-between">
                                                    <span class="customer-name font-weight-bold text-dark text-truncate" :title="item.nama">
                                                        {{ item.nama }}
                                                    </span>
                                                    <span v-if="item.is_active == 0" class="badge badge-secondary ml-1" title="Pelanggan Nonaktif">
                                                        Off
                                                    </span>
                                                </div>
                                                <small v-if="item.cabang" class="text-muted d-block font-italic">
                                                    {{ item.cabang }}
                                                </small>
                                            </td>

                                            <!-- Bulan 1 to 12 -->
                                            <td v-for="m in 12" :key="m"
                                                class="text-center align-middle p-0 month-cell"
                                                :class="getMonthCellClass(item, m)"
                                                :title="getCellTooltip(item, m)">
                                                <template v-if="item.months && item.months[m]">
                                                    <!-- PAID (Lunas) -->
                                                    <div v-if="item.months[m].status_bayar === 1" class="cell-status status-paid">
                                                        <i class="fas fa-check"></i>
                                                    </div>
                                                    <!-- UNPAID (Belum Lunas) -->
                                                    <div v-else-if="item.months[m].status_bayar === 0" class="cell-status status-unpaid">
                                                        <i class="fas fa-times"></i>
                                                    </div>
                                                </template>
                                                <!-- Empty / No Invoice -->
                                                <div v-else class="cell-status status-empty">
                                                    <span class="text-muted">-</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <!-- PAGINATION CONTROLS -->
                            <div class="d-flex align-items-center justify-content-between flex-wrap mt-3 pt-3 border-top">
                                <div class="d-flex align-items-center mb-2 mb-sm-0">
                                    <span class="small text-muted mr-2">Tampilkan:</span>
                                    <select class="form-control form-control-sm w-auto d-inline-block"
                                            v-model="pagination.itemsPerPage"
                                            @change="changeItemsPerPage">
                                        <option :value="25">25</option>
                                        <option :value="50">50</option>
                                        <option :value="100">100</option>
                                        <option :value="200">200</option>
                                    </select>
                                    <span class="small text-muted ml-2">
                                        Menampilkan {{ paginationFrom }} - {{ paginationTo }} dari {{ totalItems }} data
                                    </span>
                                </div>

                                <div class="pagination-buttons d-flex align-items-center">
                                    <button class="btn btn-sm btn-outline-primary mr-1"
                                            :disabled="pagination.page <= 1 || loading"
                                            @click="goToPage(1)" title="Halaman Pertama">
                                        <i class="fas fa-angle-double-left"></i>
                                    </button>
                                    <button class="btn btn-sm btn-outline-primary mr-2"
                                            :disabled="pagination.page <= 1 || loading"
                                            @click="goToPage(pagination.page - 1)">
                                        <i class="fas fa-chevron-left mr-1"></i> Prev
                                    </button>

                                    <span class="mx-2 small font-weight-bold">
                                        Hal {{ pagination.page }} dari {{ lastPage || 1 }}
                                    </span>

                                    <button class="btn btn-sm btn-outline-primary ml-2"
                                            :disabled="pagination.page >= lastPage || loading"
                                            @click="goToPage(pagination.page + 1)">
                                        Next <i class="fas fa-chevron-right ml-1"></i>
                                    </button>
                                    <button class="btn btn-sm btn-outline-primary ml-1"
                                            :disabled="pagination.page >= lastPage || loading"
                                            @click="goToPage(lastPage)" title="Halaman Terakhir">
                                        <i class="fas fa-angle-double-right"></i>
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { formatRupiah } from '../../helpers/format'
import KantorCabang from '../../base-components/KantorCabang.vue'
import TextSearch from '../../base-components/TextSearch.vue'

export default {
    name: 'RekapInvoiceTahunan',

    components: {
        KantorCabang,
        TextSearch
    },

    data() {
        const currentYear = new Date().getFullYear()
        const years = []
        for (let y = currentYear + 1; y >= 2022; y--) {
            years.push(y)
        }

        return {
            filter: {
                tipe: 1, // 1: PPPOE, 2: Corporate
                tahun: currentYear,
                kantor: null,
                status_active: '',
                search: ''
            },

            yearOptions: years,
            statusOptions: [
                { text: 'Semua Status', value: '' },
                { text: 'Aktif Saja', value: 1 },
                { text: 'Nonaktif Saja', value: 0 }
            ],

            monthNames: [
                'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
                'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
            ],

            items: [],
            totalItems: 0,
            lastPage: 1,
            loading: false,
            exporting: false,

            pagination: {
                page: 1,
                itemsPerPage: 50
            },

            searchTimeout: null
        }
    },

    computed: {
        paginationFrom() {
            if (this.totalItems === 0) return 0
            return (this.pagination.page - 1) * this.pagination.itemsPerPage + 1
        },

        paginationTo() {
            const end = this.pagination.page * this.pagination.itemsPerPage
            return end > this.totalItems ? this.totalItems : end
        }
    },

    mounted() {
        this.fetchData()
    },

    methods: {
        formatRupiah,

        changeTab(tipe) {
            if (this.filter.tipe === tipe) return
            this.filter.tipe = tipe
            this.pagination.page = 1
            this.fetchData()
        },

        onFilterChange() {
            this.pagination.page = 1
            this.fetchData()
        },

        onSearchInput() {
            clearTimeout(this.searchTimeout)
            this.searchTimeout = setTimeout(() => {
                this.pagination.page = 1
                this.fetchData()
            }, 400)
        },

        goToPage(page) {
            if (page < 1 || page > this.lastPage) return
            this.pagination.page = page
            this.fetchData()
        },

        changeItemsPerPage() {
            this.pagination.page = 1
            this.fetchData()
        },

        getMonthName(m) {
            return this.monthNames[m - 1] || ''
        },

        getMonthCellClass(item, m) {
            const inv = item.months && item.months[m]
            if (!inv) return 'cell-bg-empty'
            if (inv.status_bayar === 1) return 'cell-bg-paid'
            if (inv.status_bayar === 0) return 'cell-bg-unpaid'
            return ''
        },

        getCellTooltip(item, m) {
            const monthName = this.getMonthName(m)
            const inv = item.months && item.months[m]
            if (!inv) {
                return `${item.nama} - Bulan ${m} (${monthName} ${this.filter.tahun}): Tidak Ada Tagihan`
            }
            const status = inv.status_bayar === 1 ? 'LUNAS (PAID)' : 'BELUM LUNAS (UNPAID)'
            const nominal = formatRupiah(inv.total_bayar)
            let text = `${item.nama} - Bulan ${m} (${monthName} ${this.filter.tahun})\nStatus: ${status}\nNominal: ${nominal}`
            if (inv.id) text += `\nNo. Invoice: ${inv.id}`
            if (inv.tanggal_bayar) text += `\nTanggal Bayar: ${inv.tanggal_bayar}`
            return text
        },

        async fetchData() {
            this.loading = true
            try {
                const res = await axios.get('api/laporan/rekap_invoice_tahunan', {
                    params: {
                        page: this.pagination.page,
                        per_page: this.pagination.itemsPerPage,
                        tahun: this.filter.tahun,
                        tipe: this.filter.tipe,
                        kantor_id: this.filter.kantor?.id || null,
                        status_active: this.filter.status_active,
                        search: this.filter.search
                    }
                })

                this.items = res.data.data || []
                this.totalItems = res.data.total || 0
                this.lastPage = res.data.last_page || 1
            } catch (error) {
                console.error('Gagal mengambil data rekap tahunan:', error)
            } finally {
                this.loading = false
            }
        },

        async exportToExcel() {
            this.exporting = true
            try {
                // Ambil semua data tanpa pagination
                const res = await axios.get('api/laporan/rekap_invoice_tahunan', {
                    params: {
                        per_page: -1,
                        all: 1,
                        tahun: this.filter.tahun,
                        tipe: this.filter.tipe,
                        kantor_id: this.filter.kantor?.id || null,
                        status_active: this.filter.status_active,
                        search: this.filter.search
                    }
                })

                const rows = res.data.data || []
                if (rows.length === 0) {
                    alert('Tidak ada data untuk diekspor.')
                    return
                }

                // Bangun CSV content
                const tipeLabel = this.filter.tipe === 1 ? 'PPOE' : 'KORPORAT'
                const headers = ['No', 'ID', 'nama', 'cabang', 'status']
                for (let m = 1; m <= 12; m++) {
                    headers.push(`Bulan ${m}`)
                }

                const csvRows = [headers.join(',')]

                rows.forEach((row, idx) => {
                    const rowData = [
                        idx + 1,
                        `"${row.id}"`,
                        `"${(row.nama || '').replace(/"/g, '""')}"`,
                        `"${(row.cabang || '').replace(/"/g, '""')}"`,
                        row.is_active == 1 ? 'Aktif' : 'Nonaktif'
                    ]

                    for (let m = 1; m <= 12; m++) {
                        const inv = row.months && row.months[m]
                        if (!inv) {
                            rowData.push('""')
                        } else if (inv.status_bayar === 1) {
                            rowData.push('"PAID"')
                        } else {
                            rowData.push('"UNPAID"')
                        }
                    }

                    csvRows.push(rowData.join(','))
                })

                const csvString = '\uFEFF' + csvRows.join('\r\n')
                const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' })
                const url = URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.setAttribute('href', url)
                link.setAttribute('download', `matriks_tagihan_tahunan_${tipeLabel}_${this.filter.tahun}.csv`)
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            } catch (err) {
                console.error('Gagal mengekspor data:', err)
                alert('Terjadi kesalahan saat mengekspor data.')
            } finally {
                this.exporting = false
            }
        }
    }
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}

/* Nav Pills Custom Tabs */
.custom-nav-pills .nav-link {
    border-radius: 6px;
    padding: 8px 24px;
    font-size: 14px;
    background-color: #f1f3f5;
    color: #495057;
    transition: all 0.2s ease;
}

.custom-nav-pills .nav-link:hover {
    background-color: #e9ecef;
    color: #007bff;
}

.custom-nav-pills .nav-link.active {
    background-color: #007bff !important;
    color: #ffffff !important;
    box-shadow: 0 2px 4px rgba(0, 123, 255, 0.3);
}

/* Legend badges */
.legend-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: bold;
    color: #fff;
}

.legend-paid {
    background-color: #2e7d32;
}

.legend-unpaid {
    background-color: #d32f2f;
}

.legend-empty {
    background-color: #e0e0e0;
    color: #616161;
}

/* Table Responsive Wrapper */
.table-responsive-wrapper {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    background: #fff;
    min-height: 200px;
}

/* Table Styling */
.rekap-tahunan-table {
    width: 100%;
    table-layout: auto;
    border-collapse: separate;
    border-spacing: 0;
}

.rekap-tahunan-table thead th {
    background-color: #f8f9fa;
    color: #343a40;
    font-size: 13px;
    font-weight: 700;
    border: 1px solid #dee2e6 !important;
    padding: 8px 6px;
}

.rekap-tahunan-table tbody td {
    border: 1px solid #dee2e6 !important;
    padding: 6px 8px;
    font-size: 13px;
    height: 42px;
}

/* Specific column widths */
.col-no {
    width: 45px;
    min-width: 45px;
}

.col-inet {
    width: 110px;
    min-width: 100px;
    font-family: monospace;
    font-size: 13px;
}

.col-nama {
    min-width: 200px;
    max-width: 320px;
}

.col-bulan-header {
    background-color: #eef2f7 !important;
    font-size: 13px;
    letter-spacing: 0.5px;
}

.col-month-num {
    width: 44px;
    min-width: 40px;
    max-width: 50px;
    background-color: #f1f3f5 !important;
}

.nama-cell {
    white-space: normal;
    word-break: break-word;
}

.customer-name {
    font-size: 13px;
}

.inet-id-cell {
    color: #1a237e;
    letter-spacing: 0.3px;
}

/* Month Cell and Status Badges */
.month-cell {
    position: relative;
    cursor: default;
    transition: filter 0.15s ease;
}

.month-cell:hover {
    filter: brightness(0.92);
}

.cell-status {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: bold;
    min-height: 38px;
}

/* Green Paid cell matching screenshot */
.cell-bg-paid,
.status-paid {
    background-color: #2e7d32 !important;
    color: #ffffff !important;
}

.status-paid i {
    font-size: 14px;
    stroke: #ffffff;
}

/* Red Unpaid cell matching screenshot */
.cell-bg-unpaid,
.status-unpaid {
    background-color: #d32f2f !important;
    color: #ffffff !important;
}

.status-unpaid i {
    font-size: 14px;
}

/* Empty cell */
.cell-bg-empty,
.status-empty {
    background-color: #ffffff;
}

.status-empty span {
    color: #adb5bd;
    font-weight: normal;
}

/* Loading Overlay */
.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.85);
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .rekap-tahunan-table thead th,
    .rekap-tahunan-table tbody td {
        font-size: 11px !important;
        padding: 4px 3px !important;
    }

    .col-inet {
        width: 85px;
        min-width: 80px;
    }

    .col-nama {
        min-width: 140px;
    }

    .col-month-num {
        width: 32px;
        min-width: 30px;
    }

    .cell-status {
        min-height: 32px;
    }
}
</style>
